import { render, staticRenderFns } from "./ednDialog.vue?vue&type=template&id=40a4ab36&"
import script from "./ednDialog.vue?vue&type=script&lang=js&"
export * from "./ednDialog.vue?vue&type=script&lang=js&"
import style0 from "./ednDialog.vue?vue&type=style&index=0&id=40a4ab36&prod&lang=scss&"


/* normalize component */
import normalizer from "!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports